import { createAsyncThunk } from "@reduxjs/toolkit"

import { API } from "redux/api"

export const fetchSettings = createAsyncThunk("settings/fetch", async () => {
  const response = await API.get("/settings")
  return response.data
})
